import axios from 'axios';
import { clearSession } from './utils/session';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

/** Public / auth pages where a 401 must not hard-redirect to login. */
const PUBLIC_PATH_PREFIXES = [
  '/login',
  '/acknowledge',
  '/set-password',
  '/form',
  '/thank-you',
  '/thankyou',
];

const isPublicPath = (pathname = '') =>
  PUBLIC_PATH_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

/** Auth endpoints that return 401 for bad credentials (not an expired session). */
const isAuthChallengeUrl = (url = '') =>
  /\/undertaking\/dashboard\/login\b/.test(url) ||
  /\/auth\/providers\b/.test(url);

// Attach the JWT (if present) to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On auth failure, clear session and send the user back to login —
// but never hijack public acknowledge / set-password / login flows.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname || '';
      const reqUrl = String(error.config?.url || '');
      const skip =
        error.config?.skipAuthRedirect ||
        isPublicPath(path) ||
        isAuthChallengeUrl(reqUrl) ||
        !localStorage.getItem('adminToken');

      if (!skip) {
        clearSession();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
